import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import styled from 'styled-components'

// Elements
import ParseContent from 'components/shared/ParseContent'

// Icons
import Logo from 'img/logoblank.inline.svg'
import CMLogo from 'img/clearmind-logo.inline.svg'

const FooterTop = styled.div`
  
`

const FooterBottom = styled.div`
  background: ${props => props.theme.color.face.main};
  background: ${props => `linear-gradient(90deg, rgba(${props.theme.color.gradient.main.to},1) 0%, rgba(${props.theme.color.gradient.main.from},1) 85%)`};
  color: ${props => props.theme.color.text.light};
`

const Brand = styled.div`
  background-color: ${props => props.theme.color.face.light};
  padding: 12px 22px;
  border-radius: 30px;
`

const BrandLogo = styled(Logo)`
  height: 30px;
  width: 181px;
`

const CMAnchor = styled.a`
  font-size: 0;
`

const StyledCMLogo = styled(CMLogo)`
  width: 150px;
  height: 45px;
`

const Info = styled(ParseContent)`
  & a {
    font-size: ${props => props.theme.font.size.xm};
    font-weight: ${props => props.theme.font.weight.l};
  }
`

const Menu = styled.div`
  & a {
    color: ${props => props.theme.color.text.light};

    &[aria-current] {
      font-weight: ${props => props.theme.font.weight.l};
    }
  }
`

const Stripe = styled.div`
  background-color: ${props => props.theme.color.text.light};
  width: 1px;
  height: 10px;
  margin: 0 5px;
`

const Footer = ({ bigFooter = false }) => {
  const {
    fields
  } = useStaticQuery(graphql`
    {
      fields: wpComponent(id: {eq: "cG9zdDoxMDk="}) {
        footer {
          info {
            description
          }

          navigation {
            menu {
              link {
                title
                url
              }
            }
            conditions {
              link {
                title
                url
              }
            }
            download {
              localFile {
                publicURL
              }
            }
            downloadName
          }
        }
      }
    }
  `)

  return (
    <>
      <FooterTop className="container mb-n3">
        <Brand className="mb-n2 d-inline-block">
          <BrandLogo />
        </Brand>
      </FooterTop>
      <FooterBottom>
        <div className={`container${bigFooter ? ' pb-5' : ''}`}>
          <div className={`row py-5${bigFooter ? ' mb-4' : ''}`}>
            <div className="col-lg-6 mt-2">
              <Info content={fields.footer.info.description} />
              <div className="d-flex align-items-center mt-5">
                <CMAnchor href="https://clearmind.nu" target="_blank" rel="noreferrer">
                  ClearMind
                  <StyledCMLogo />
                </CMAnchor>
              </div>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-2">
              <Menu className="d-sm-flex align-items-center justify-content-between">
                {fields.footer.navigation.menu.map(({ link: { url, title } }, index) => (
                  // eslint-disable-next-line
                  <Link key={`menu-${index}`} to={url} className="d-sm-flex d-block">
                    {title}
                  </Link>
                ))}
              </Menu>
              <Menu className="mt-5 d-flex align-items-center justify-content-end">
                <a 
                  href={fields.footer.navigation.download.localFile.publicURL} 
                  className="font-size-sm"
                  target="_blank"
                  rel="noreferrer"
                >
                  {fields.footer.navigation.downloadName}
                </a>
                <Stripe />
                {fields.footer.navigation.conditions.map(({ link: { url, title } }, index) => (
                  // eslint-disable-next-line
                  <div key={`conditions-${index}`} className="d-flex align-items-center">
                    {index > 0 && (
                      // eslint-disable-next-line
                      <Stripe />
                    )}
                    <Link 
                      to={url} 
                      className="font-size-sm"
                    >
                      {title}
                    </Link>
                  </div>
                ))}
              </Menu>
            </div>
          </div>
        </div>
      </FooterBottom>
    </>
  )
}

export default Footer
